module.exports = __webpack_public_path__ + "static/media/flag-ku.5a46a0bc.webp";